import { render, staticRenderFns } from "./KnChart.vue?vue&type=template&id=7356b600"
import script from "./KnChart.js?vue&type=script&lang=js&external"
export * from "./KnChart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports